import { focusDeepWithin } from "@otto-ec/otto-components-utils/utils/focus/focusDeepWithin";
import type { CustomElement } from "./utils";
import { completeElementInit, registerElementInit } from "./performance";
import { addInstance } from "./telemetry";
import { cleanUpFalsyBooleanAttributes } from "./cleanup";

export const extendElementBase = (Base: CustomElement): CustomElement =>
  class extends Base {
    constructor(...args: unknown[]) {
      super(...args);
      /*                               */
      addInstance(this.tagName);
      /*                                         */
      registerElementInit(this);
    }

    connectedCallback(): void {
      /*                                                   */
      cleanUpFalsyBooleanAttributes(this);

      /*                                                                          */
      const res = super.connectedCallback();

      /*                                                   */
      completeElementInit(this);

      /*                                                                         */
      return res;
    }

    /*                                      */
    focus(): void {
      /*                            */
      /*                                                                    */
      /*                                                            */
      /*                                                                                     */
      /*                                                                                                                                                      */
      /*                                                                                                    */
      /*                                                                                                                */
      focusDeepWithin(this);
    }
  };
